import React from "react";
import {
  Box,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

/**
 * Skeleton loader for the Verification Center table. Mirrors the loaded
 * table layout (ID, type chip, user info, optional location, status chip, actions).
 */
export default function AdminVerificationsSkeleton({ showLocationCol = false }) {
  const headers = [
    "ID",
    "Type",
    "User / Company",
    ...(showLocationCol ? ["Location"] : []),
    "Status",
    "Actions",
  ];

  return (
    <TableContainer>
      <Table sx={{ minWidth: 960 }}>
        <TableHead sx={{ bgcolor: (theme) => theme.palette.table.headBg }}>
          <TableRow>
            {headers.map((h) => (
              <TableCell key={h} sx={{ py: 2 }}>
                <Skeleton variant="text" width={70} height={16} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[0, 1, 2, 3, 4].map((i) => (
            <TableRow key={i}>
              <TableCell>
                <Skeleton variant="text" width={90} height={18} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rounded" width={70} height={24} sx={{ borderRadius: 999 }} />
              </TableCell>
              <TableCell>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Skeleton variant="circular" width={36} height={36} />
                  <Box>
                    <Skeleton variant="text" width={140} height={18} />
                    <Skeleton variant="text" width={100} height={14} />
                  </Box>
                </Stack>
              </TableCell>
              {showLocationCol && (
                <TableCell>
                  <Skeleton variant="text" width={120} height={18} />
                </TableCell>
              )}
              <TableCell>
                <Skeleton variant="rounded" width={70} height={24} sx={{ borderRadius: 999 }} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rounded" width={72} height={32} sx={{ borderRadius: 1.25 }} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
